require("./../../../bower_components/parsleyjs/dist/parsley.js");
require("./../../../bower_components/parsleyjs/dist/i18n/ru.js");

module.exports = function() {

	$('.feedback').each(function(){
		$(this).parsley();
	});

};